import React from 'react';
import LegalPage from '../components/LegalPage';
import Seo from '../components/Seo';

export default function EulaPage() {
  return (
    <LegalPage title="End User License Agreement">
      <Seo
        path="/eula"
        title="End User License Agreement — LottoPickle"
        description="The license terms for using the LottoPickle web application and its features."
      />
      <h2>1. Agreement</h2>
      <p>This End User License Agreement ("EULA") is a legal agreement between you and LottoPickle for your use of the LottoPickle web application and any associated services (collectively, "the Application").</p>
      <p>By using the Application, you agree to be bound by the terms of this EULA. If you do not agree, do not use the Application.</p>

      <h2>2. License Grant</h2>
      <p>LottoPickle grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Application for personal, non-commercial use, subject to the terms of this EULA.</p>

      <h2>3. Restrictions</h2>
      <p>You may not:</p>
      <ul>
        <li>Copy, modify, or distribute the Application or its content</li>
        <li>Reverse-engineer, decompile, or disassemble any part of the Application</li>
        <li>Use the Application to build a competing product or service</li>
        <li>Use automated tools to scrape, crawl, or extract data from the Application</li>
        <li>Sublicense, rent, lease, or lend access to the Application</li>
        <li>Remove or alter any proprietary notices or branding</li>
      </ul>

      <h2>4. Subscription Terms</h2>
      <ul>
        <li>Free features are available without payment and may be modified at any time.</li>
        <li>Pro features require an active subscription managed through Stripe.</li>
        <li>Subscriptions renew automatically at the end of each billing cycle (monthly or annually) unless cancelled before the renewal date.</li>
        <li>You may cancel your subscription at any time. Access to Pro features continues until the end of the current billing period.</li>
        <li>Prices may change with notice. Existing subscribers will be notified before any price increase takes effect on their renewal.</li>
      </ul>

      <h2>5. Data and Content</h2>
      <p>Lottery draw data displayed in the Application is sourced from publicly available government databases. LottoPickle does not claim ownership of this data. All analysis, visualizations, and derived content are the intellectual property of LottoPickle.</p>

      <h2>6. Disclaimer</h2>
      <p>THE APPLICATION IS PROVIDED FOR ENTERTAINMENT AND DATA ANALYSIS PURPOSES ONLY. LOTTOPICKLE MAKES NO REPRESENTATIONS OR WARRANTIES REGARDING THE ACCURACY, RELIABILITY, OR COMPLETENESS OF ANY DATA OR ANALYSIS. HISTORICAL LOTTERY DATA HAS NO PREDICTIVE VALUE FOR FUTURE DRAWS. LOTTERY OUTCOMES ARE RANDOM EVENTS.</p>
      <p>THE APPLICATION IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED.</p>

      <h2>7. Limitation of Liability</h2>
      <p>IN NO EVENT SHALL LOTTOPICKLE BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING FROM YOUR USE OF THE APPLICATION, INCLUDING BUT NOT LIMITED TO FINANCIAL LOSSES FROM LOTTERY PLAY, LOSS OF DATA, OR INTERRUPTION OF SERVICE.</p>

      <h2>8. Termination</h2>
      <p>We may terminate or suspend your access to the Application at any time, without notice, for conduct that we believe violates this EULA or is harmful to other users, us, or third parties. Upon termination, your license to use the Application ceases immediately.</p>

      <h2>9. Governing Law</h2>
      <p>This EULA shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles.</p>

      <h2>10. Changes to This EULA</h2>
      <p>We reserve the right to update this EULA at any time. Changes take effect upon posting. Continued use of the Application constitutes acceptance of the updated EULA.</p>

      <h2>11. Contact</h2>
      <p>For questions about this EULA, contact us at <a href="mailto:info@lottopickle.com">info@lottopickle.com</a>.</p>
    </LegalPage>
  );
}
